import { render, staticRenderFns } from "./CPBtn.vue?vue&type=template&id=7ae4871c&"
import script from "./CPBtn.vue?vue&type=script&lang=ts&"
export * from "./CPBtn.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports